/**
 * @module utilities for working with coordinates and sizes
 */
export type Size = {
  width: number;
  height: number;
};

export type Margin = {
  top: number;
  right: number;
  bottom: number;
  left: number;
};

export const calcInnerSize = (size: Size, margin: Margin): Size => ({
  width: size.width - margin.left - margin.right,
  height: size.height - margin.top - margin.bottom,
});

/**
 * Calculate size as aspect ratio of height.
 * @example
 * calcSizeAsAspectRatioOfHeight(100, 16/9);
 */
export const calcSizeAsAspectRatioOfHeight = (
  height: number,
  aspectRatio: number,
): Size => ({
  width: height * aspectRatio,
  height,
});

export const calcWidthFromAspect = (
  height: number,
  aspectRatio: number,
): number => height * aspectRatio;
